import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MaxDiscountsLimitPage } from './max-discounts-limit.page';
import { ModuleSharedModule } from "../../modules/module-shared.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModuleSharedModule,
],
  declarations: [MaxDiscountsLimitPage],
  exports: [MaxDiscountsLimitPage],
})
export class MaxDiscountsLimitPageModule {}
